import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { JobService } from '../../services/job.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-display-job',
    templateUrl: './display-job.component.html',
    styleUrls: ['./display-job.component.css', '../../app.component.css']
})

export class DisplayJobComponent implements OnInit {

    job: any = [];

    id: string;

    gjSubs: any;
    gsSubs: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private jobService: JobService,
                private subsidiaryService: SubsidiaryService) {
        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.gjSubs = this.jobService.getJob(this.id).subscribe((jobObj:any) => {
                this.gjSubs.unsubscribe();

                this.gsSubs = this.subsidiaryService.getSubsidiary(jobObj.subsidiaryId).subscribe(subsidiaryObj => {
                    this.gsSubs.unsubscribe();

                    this.job = jobObj;

                    this.job.subsidiaryName = subsidiaryObj.name;
                });
            });

            
        });
    }

    ngOnInit() {

    }

}
